"use strict";

require('./custom-material-select');

let toastr = require('./toastr.js');

(function ($) {

    document.addEventListener("DOMContentLoaded", function () {

        $('#menu-display-link').on('click', function (event) {
            event.preventDefault();
            $('#menu-display-link img.d-none').each(function (i, elem) {
                if ($(elem).hasClass('d-none') && $(elem).hasClass('open-menu-icon')) {
                    ks_pro2.layout.menu.hide();
                } else if ($(elem).hasClass('d-none') && $(elem).hasClass('close-menu-icon')) {
                    ks_pro2.layout.menu.show();
                }
            });
        });

        $('#menu-resize-link').on('mouseup', function (event) {
            event.preventDefault();
            $('#menu-resize-link img.d-none').each(function (i, elem) {
                if ($(elem).hasClass('d-none') && $(elem).hasClass('stretch-menu-icon')) {
                    ks_pro2.layout.menu.shrink();
                } else if ($(elem).hasClass('d-none') && $(elem).hasClass('shrink-menu-icon')) {
                    ks_pro2.layout.menu.stretch();
                }
            });
        });

        $('#menu-close-link').on('click', function (event) {
            event.preventDefault();
            ks_pro2.layout.menu.hide();
        });

        $('[data-toggle="tooltip"]').tooltip({delay: { "show": 200, "hide": 100 }});

        var sideNavScrollbar = document.querySelector('.custom-scroller');
        if(sideNavScrollbar) {
            var ps = new PerfectScrollbar(sideNavScrollbar, {
                wheelPropagation: false
            });
        }

        $('#left-slide-out')
            .on('mouseenter', function (event) {
                event.preventDefault();
                if ($('main').hasClass('shrinked')) {
                    setTimeout(function () {
                        ks_pro2.layout.menu.hoverstretch();
                    }, 100);
                }
            })
            .on('mouseleave', function (event) {
                event.preventDefault();
                if ($('main').hasClass('shrinked')) {
                    setTimeout(function () {
                        ks_pro2.layout.menu.hovershrink();
                    }, 100);
                }
            });

        $('html,body').animate({ scrollTop: 0 }, '1');

        $('#user-menu').on('click',function(event){
            event.stopPropagation ();
        });

        $('#wizard-modal-show-btn').on('click',function(event){
            if(window.sessionStorage.getItem(['modalWizard']) == '1' ){
                $('#wizardModal2').modal('show');
                $('#wizardMode1').prop('checked', true);
                $('#wizardMode2').prop('checked', true);
            }else{
                $('#wizardModal1').modal('show');
                $('#wizardMode1').prop('checked', false);
                $('#wizardMode2').prop('checked', false);
            }
        });

        $('#wizard-modal-hide-btn1').on('click',function(event){
            const selectTarget = $('[name="wizardMode1"]:checked');
            if(selectTarget.val() == "1") {
                window.sessionStorage.setItem(['modalWizard'],['1']);
                $('#wizardModal1').modal('hide');
            }else{
                window.sessionStorage.removeItem(['modalWizard']);
                $('#wizardModal1').modal('hide');
            }
        });

        $('#wizard-modal-hide-btn2').on('click',function(event){
            const selectTarget = $('[name="wizardMode2"]:checked');
            if(selectTarget.val() == "1") {
                window.sessionStorage.setItem(['modalWizard'],['1']);
                $('#wizardModal2').modal('hide');
            }else{
                window.sessionStorage.removeItem(['modalWizard']);
                $('#wizardModal2').modal('hide');
            }
        });

        $('.navbar-collapse a').click(function(){
            $(".navbar-collapse").collapse('hide');
        });

        $(document).on('hidden.bs.modal', '.modal', function () {
            $('.modal:visible').length && $(document.body).addClass('modal-open');
        });

        $('[data-toggle-second="tooltip"]').tooltip();

        $('.modal .custom-modal-close').on('click',function(event){
            const target = $(event.currentTarget);
            const modal = target.closest('.modal');
            modal.modal('hide');
        })

    });

    var ks_pro2 = {};
    ks_pro2.layout = {
        menu: {
            sideNavOverlayElement: '<div id="sidenav-overlay"></div>',
            hide: function () {
                $('#menu-display-link img.open-menu-icon').removeClass('d-none');
                $('#menu-display-link img.close-menu-icon').addClass('d-none');
                $('#left-slide-out').addClass('fixed');
                $('#sidenav-overlay').remove();
            },
            show: function () {
                $('#menu-display-link img.close-menu-icon').removeClass('d-none');
                $('#menu-display-link img.open-menu-icon').addClass('d-none');
                $('#left-slide-out').removeClass('fixed');
                $('body').append(this.sideNavOverlayElement);
                $('#sidenav-overlay').on('click', function (event) {
                    ks_pro2.layout.menu.hide();
                });
            },
            shrink: function () {
                $('#menu-resize-link img.stretch-menu-icon').removeClass('d-none');
                $('#menu-resize-link img.shrink-menu-icon').addClass('d-none');
                $('#left-slide-logo-img').addClass('shrinked');
                $('#left-slide-out').addClass('shrinked');
                $('header').addClass('shrinked');
                $('main').addClass('shrinked');
                $('footer').addClass('shrinked');
                $('#sidenav-overlay').remove();
            },
            stretch: function () {
                $('#menu-resize-link img.shrink-menu-icon').removeClass('d-none');
                $('#menu-resize-link img.stretch-menu-icon').addClass('d-none');
                $('#left-slide-logo-img').removeClass('shrinked');
                $('#left-slide-out').removeClass('shrinked');
                $('header').removeClass('shrinked');
                $('main').removeClass('shrinked');
                $('footer').removeClass('shrinked');
            },
            hoverstretch: function () {
                $('#left-slide-logo-img').removeClass('shrinked');
                $('#left-slide-out').removeClass('shrinked');
            },
            hovershrink: function () {
                if ($('main').hasClass('shrinked')) {
                    $('#left-slide-logo-img').addClass('shrinked');
                    $('#left-slide-out').addClass('shrinked');
                }
            },
        }
    };

    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "md-toast-bottom-left",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": 300,
        "hideDuration": 1000,
        "timeOut": 5000,
        "extendedTimeOut": 1000,
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    window.ks_pro2 = {};
    window.ks_pro2.common = {
        spiner:{
            show: function () {
                $('#preloader-full').removeClass('d-none');
            },
            hide: function () {
                $('#preloader-full').addClass('d-none');
            }
        },
        toastr: toastr,
        errorMessageFormat:function (msg) {
            let ret = "";
            if(typeof(msg)==='object') {
                let values = Object.values(msg);
                values.forEach((value) => {
                    if (Array.isArray(value)) {
                        ret = ret + value[0] + "<br>"
                    } else {
                        ret = ret + value + "<br>"
                    }
                });
            }else if(typeof(msg)==='string'){
                ret = msg;
            }
            ret.trim();
            return ret;
        },
        autodownload:function(data, filename) {

            var oReq = new XMLHttpRequest();
            oReq.open("GET", data, true);
            oReq.responseType = "blob";
            oReq.onload = function(ev) {
                if(oReq.status !== 200){
                    window.ks_pro2.common.toastr.error('ダウンロードに失敗しました。');
                    return;
                }
                var blob = oReq.response;
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    window.navigator.msSaveBlob(blob, filename);
                }else {
                    var blobURL = window.URL.createObjectURL(blob);
                    var tempLink = document.createElement('a');
                    tempLink.style.display = 'none';
                    tempLink.href = blobURL;
                    tempLink.setAttribute('download', filename);

                    if (typeof tempLink.download === 'undefined') {
                        tempLink.setAttribute('target', '_blank');
                    }

                    document.body.appendChild(tempLink);
                    tempLink.click();

                    setTimeout(function() {
                        document.body.removeChild(tempLink);
                        window.URL.revokeObjectURL(blobURL);
                    }, 0)
                }
            };
            oReq.send();
        },
        getUuid:function() {
            let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
            for (let i = 0, len = chars.length; i < len; i++) {
                switch (chars[i]) {
                    case "x":
                        chars[i] = Math.floor(Math.random() * 16).toString(16);
                        break;
                    case "y":
                        chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
                        break;
                }
            }
            return chars.join("");
        },
        formatCurrency: function(num, scale) {
            var re = /(\d)(?=(\d\d\d)+(?!\d))/g;
            return Number(num).toFixed(scale).replace(re, '$1,');
        },
    };

})(jQuery);

jQuery.fn.serializeObject = function() {
    var data = {};
    $.each( this.serializeArray(), function( key, obj ) {
        var a = obj.name.match(/(.*?)\[(.*?)\]/);
        if(a !== null)
        {
            var subName = new String(a[1]);
            var subKey = new String(a[2]);
            if( !data[subName] ) {
                data[subName] = { };
                data[subName].length = 0;
            }
            if (!subKey.length) {
                subKey = data[subName].length;
            }
            if( data[subName][subKey] ) {
                if( $.isArray( data[subName][subKey] ) ) {
                    data[subName][subKey].push( obj.value );
                } else {
                    data[subName][subKey] = [data[subName][subKey]];
                    data[subName][subKey].push( obj.value );
                }
            } else {
                data[subName][subKey] = obj.value;
            }
            data[subName].length++;
        } else {
            var keyName = new String(obj.name);
            if( data[keyName] ) {
                if( $.isArray( data[keyName] ) ) {
                    data[keyName].push( obj.value );
                } else {
                    data[keyName] = [data[keyName]];
                    data[keyName].push( obj.value );
                }
            } else {
                data[keyName] = obj.value;
            }
        }
    });
    return data;
};

// if (window.history && history.pushState) {
//     addEventListener('load', function() {
//         history.pushState(null, null, null);
//         addEventListener('popstate', function() {
//             var stayOnPage = confirm("行った変更が保存されない可能性があります。移動してもよろしいですか？");
//             if (stayOnPage) {
//                 history.back()
//             } else {
//                 history.pushState(null, null, null);
//             }
//         });
//     });
// }
